export default "/images/module_icon_pa.png?f7d70b39cfd7817ad90cfc297cbf3d96";